import { InjectionToken } from '@angular/core';

export interface MockEnvironmentInterface {
  globally: string;
  modules?: { [module: string]: boolean };
}

export const MOCK_API = new InjectionToken<MockEnvironmentInterface>('MOCK_API');
